export default {
  dockName: 'Airport Name',
  noWaylineTask: 'No wayline task',
  battery: 'Battery',
  rightBattery: 'Right Battery',
  temperature: 'Temp',
  temperatureNone: 'N/A',
  capacity: 'Charge',
  dockLiveVideo: 'Airport Live Video',
  aiAlarm: 'AI Alarm',
  pictureInPicture: 'Picture in Picture',
  alarmType: 'Alarm Type',
  alarmImage: 'Alarm Image',
  alarmTime: 'Alarm Time',
  zoomFactor: 'Zoom {value}X',
  droneLiveVideo: 'Aircraft Live Video',
  hideDetectionVideo: 'Hide Detection Video',
  showDetectionVideo: 'Show Detection Video',
  imageTransmission: 'Video Link',
  originalVideo: 'Original Video',
  streamStarting: 'Starting live stream...',
  detectionVideo: 'Detection Video',
  detectionVideoCompleted: 'Detection video completed',
  pullingStream: 'Pulling stream...',
  cameraWide: 'Wide',
  cameraZoom: 'Zoom',
  cameraIr: 'IR',
  fullscreen: 'Fullscreen',
  exitFullscreen: 'Exit Fullscreen',
  switchCameraMode: 'Switch Camera Mode',
  photoMode: 'Photo Mode',
  videoMode: 'Video Mode',
  smartLowLight: 'Smart Low Light',
  panoramaPhoto: 'Panorama',
  directedPhoto: 'Directed Photo',
  cameraMode: 'Camera Mode',
  gimbalSwitch: 'Gimbal Switch',
  gimbalRecenter: 'Recenter',
  gimbalDown: 'Down',
  gimbalYawRecenter: 'Yaw Recenter',
  gimbalPitchDown: 'Pitch Down',
  takePhoto: 'Take Photo',
  stopRecording: 'Stop Recording',
  record: 'Record',
  light: 'Light',
  turnOffLight: 'Turn Off Light',
  turnOnLight: 'Turn On Light',
  flash: 'Strobe',
  confirmTurnOffFlash: 'Turn off strobe?',
  confirmTurnOnFlash: 'Turn on strobe?',
  textAnnouncement: 'Text Announcement',
  voiceAnnouncement: 'Voice Announcement',
  voiceRecordAnnouncement: 'Voice Record Announcement',
  infer: 'Infer',
  trace: 'Track',
  oneKeyTakeoff: 'One-key Takeoff',
  returnHome: 'Return Home',
  suspendTask: 'Suspend Task',
  recoverTask: 'Resume Task',
  stopPointFlight: 'Stop Point Flight',
  debugPanel: 'Debug Panel',
  watermarkDock: 'Airport',
  watermarkDrone: 'Aircraft',
  settingSuccess: 'Settings saved',
  selectResetMode: 'Please select a reset mode',
  droneNotConnected: 'Aircraft offline. Operation unavailable',
  selectZoomLens: 'Please select a zoom lens',
  enterZoomFactor: 'Please enter zoom factor',
  droneNotConnectedZoom: 'Aircraft offline. Cannot adjust zoom',
  lensAlreadyType: 'Current lens is already {type}. Please switch to another lens',
  lensCannotSwitch: 'Cannot switch lens. Please select a lens to switch to.',
  switchCameraSuccess: 'Live camera switched successfully.',
  inferStartSuccess: 'Inference started',
  inferStopSuccess: 'Inference stopped',
  loading: 'Loading',
  cancelTrace: 'Tracking cancelled',
  startTrace: 'Tracking started',
  inferTimeout: 'Inference timeout',
  waitTimeout: 'Wait timeout',
  traceStopSuccess: 'Tracking stopped',
  traceStartSuccess: 'Tracking started',
  detectionLabels: {
    pedestrian: 'Pedestrian',
    person: 'Person',
    bicycle: 'Bicycle',
    car: 'Car',
    van: 'Van',
    truck: 'Truck',
    tricycle: 'Tricycle',
    awningTricycle: 'Awning Tricycle',
    bus: 'Bus',
    motorcycle: 'Motorcycle',
  },
  control: {
    dockInfo: 'Airport Info',
    droneInfo: 'Drone Info',
    cabinTemperature: 'Cabin Temp',
    windSpeed: 'Wind Speed',
    rainfall: 'Rainfall',
    dockHumidity: 'Airport Humidity',
    altitude: 'Altitude',
    workingVoltage: 'Working Voltage',
    workingCurrent: 'Working Current',
    availableStorage: 'Available Storage',
    airConditioner: 'Air Conditioner',
    on: 'On',
    off: 'Off',
    batteryLevel: 'Battery',
    elevation: 'Elevation',
    returnDistance: 'RTH Distance',
    horizontalSpeed: 'Horizontal Speed',
    verticalSpeed: 'Vertical Speed',
    signal: 'Signal',
    keyGuide: 'Key Guide',
    imageAlt: 'Image',
    exitRemoteControl: 'Exit Remote Control',
    enterRemoteControl: 'Enter Remote Control',
    more: 'More',
    viewKeyGuideAria: 'View more key guide details',
    securityTakeoffAltitude: 'Safe Takeoff Alt (ALT)',
    flightWorkAltitude: 'Flight Work Alt (ALT)',
    rthAltitudeLabel: 'RTH Alt (ALT)',
    lostLinkAction: 'Lost Link Action',
    targetAltitudeAgl: 'Target Alt (AGL)',
    confirmTakeoff: 'Confirm one-key takeoff?',
    rthAltitudeRequired: 'RTH altitude is required',
    targetHeightRequired: 'Target altitude is required',
    targetHeightBelowDock: 'Target altitude cannot be lower than airport altitude. Current airport altitude: {height}m',
    securityTakeoffHeightRequired: 'Safe takeoff altitude is required',
    commanderHeightRequired: 'Command flight altitude is required',
    suspendTaskSuccess: 'Task suspended',
    resumeTaskSuccess: 'Task resumed',
    noCurrentTask: 'No active task',
    returnHomeSuccess: 'Return home succeeded',
    flightControlGranted: 'Flight control acquired',
    flightControlExited: 'Flight control exited',
    rainfallLevel: {
      0: 'No Rain',
      1: 'Light Rain',
      2: 'Moderate Rain',
      3: 'Heavy Rain',
    },
  },
}
